// src/components/iaDashboard/cards/FinishedTodayCard.jsx
import React from "react";

export default function FinishedTodayCard({ value }) {
  return (
    <div className="ia-card ia-card-finished">
      <div className="ia-card-header">
        <span className="ia-card-label">Finalizadas hoje</span>
      </div>
      <div className="ia-card-value">{value ?? 0}</div>
      <p className="ia-card-sub">
        Total de atendimentos encerrados no dia atual.
      </p>
    </div>
  );
}
